<template>

    <div class="container-fluid fixcontent " >

        <div class="row " style="margin-top: 1px; margin-bottom: -4px !important;" >
            <div class="col-md-2 text-light " style="padding-left: 0px !important;">
                <img class="col-md-12   " src="@/assets/images/headerlogo.png"   >
            </div>
            <div class="col-md-6 text-center col-7 mt-4 text-light offset-1 font-weight-semi-bold" style="font-size: 17px">
                <welcomenote/>

            </div>
            <div class="col-md-3 text-right col-4 text-light mt-1" style="font-size: 17px" >
                <p style="margin-bottom: 0.3rem"><ShowRealTime/></p>
                <a class="text-light" href="#" @click.prevent="signOut" >Login</a> / <a class="text-light" href="#" @click.prevent="signOut">Logout</a>
            </div>
        </div>

        <div class="row mt-2">
            <sidebar></sidebar>
            <div class="col-md-11 bgsecond mt-2 text-light">

                <div class="row  mt-2">



                    <div class="col-md-6 ">
                        <h1>Order History <span>{{invoice_id}}</span></h1>
                    </div>

<!--                    <div class="col-md-2">-->
<!--                        <b-input v-model="claimfilters.order_id"-->
<!--                                 @input="()=>{-->
<!--                                 this.claimfilters.page=1;-->
<!--                                 this.get_invoice_history()-->
<!--                              }"-->
<!--                                 placeholder="Order ID"></b-input>-->
<!--                    </div>-->
<!--                    <div class="col-md-2">-->
<!--                        <b-input v-model="claimfilters.customer_name"-->
<!--                                 @input="()=>{-->
<!--                                 this.claimfilters.page=1;-->
<!--                                 this.get_invoice_history()-->
<!--                              }"-->
<!--                                 placeholder="Name"></b-input>-->
<!--                    </div>-->
<!--                    <div class="col-md-2">-->
<!--                        <b-input v-model="claimfilters.phone_number"-->
<!--                                 @input="()=>{-->
<!--                                 this.claimfilters.page=1;-->
<!--                                 this.get_invoice_history()-->
<!--                              }"-->
<!--                                 placeholder="Mobile"></b-input>-->
<!--                    </div>-->


<!--                    <div class="col-md-2">-->
<!--                        <v-select-->
<!--                            v-model="claimfilters.branch_id"-->
<!--                            @input="()=>{-->
<!--                                 this.claimfilters.page=1;-->
<!--                                 this.get_invoice_history()-->
<!--                              }"-->
<!--                            class="text-dark"-->
<!--                            placeholder="Branch"-->
<!--                            :options="branches"-->

<!--                            label="name"-->
<!--                            :reduce="option => option.id"-->

<!--                        />-->
<!--                    </div>-->
<!--                    <div class="col-md-2">-->
<!--                        <v-select-->
<!--                            v-model="claimfilters.status"-->
<!--                            @input="()=>{-->
<!--                                 this.claimfilters.page=1;-->
<!--                                 this.get_invoice_history()-->
<!--                              }"-->
<!--                            class="text-dark"-->
<!--                            placeholder="Status"-->
<!--                            :options="['Pending','Approved','Completed']"-->

<!--                        />-->
<!--                    </div>-->





                    <!--                    <b-table id="customers-table"  class="bg-light" :items="filteredCustomers" :fields="fields" striped hover responsive :per-page="perPage" :current-page="currentPage">-->


                    <!--                        <template #cell(actions)="data">-->

                    <!--                            <b-link class="" :to="{ path: '/customerform',query: { type: 'edit', 'id': data.item.id } }">-->
                    <!--                                <b-button class="btn-info mb-2" > Edit </b-button>-->
                    <!--                            </b-link>-->
                    <!--                            <b-link class="mx-1" :to="{ path: '/customerform',query: { type: 'view', 'id': data.item.id } }">-->
                    <!--                                <b-button class="btn-info mb-2" > View </b-button>-->
                    <!--                            </b-link>-->
                    <!--&lt;!&ndash;                            <b-link class="mx-1" :to="{ path: '/customerform',query: { type: 'view', 'id': data.item.id } }">&ndash;&gt;-->
                    <!--&lt;!&ndash;                                <b-button class="btn-info mb-2" > Orders </b-button>&ndash;&gt;-->
                    <!--&lt;!&ndash;                            </b-link>&ndash;&gt;-->

                    <!--                        </template>-->

                    <!--                    </b-table>-->
                    <!--                    <b-pagination-->
                    <!--                        class=""-->
                    <!--                        v-model="currentPage"-->
                    <!--                        :total-rows="customers.length"-->
                    <!--                        :per-page="perPage"-->
                    <!--                        aria-controls="customers-table"-->
                    <!--                    ></b-pagination>-->
                </div>
                <div class="row mt-2" >
                    <div class="col-md-2">
                        <button class="btn-sm btn-info" @click="get_invoice_history">
                            <span v-if="showloader" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Refresh
                        </button>
                    </div>
                    <div class="col-md-2">
                    </div>

                    <div class="col-md-1">
                        <button class="btn-sm btn-info"     :disabled="invoice_history?.current_page==1" @click="get_paged_data('prev')">Previous</button>
                    </div>
                    <div class="col-md-3">
                        <span class="text-light mx-2 px-2" v-if="!showloader" style="border: 3px solid white; border-radius: 5px"> showing  ( <span v-if="invoice_history?.to-50>0">{{invoice_history?.to-50}}</span> <span v-else="">0</span>  to {{invoice_history.to}}) out of {{invoice_history.total}} records</span>
                    </div>
                    <div class="col-md-1">

                        <button class="btn-sm btn-info "    :disabled="invoice_history?.current_page==totalPages" @click="get_paged_data('next')">Next</button>
                    </div>
                    <div class="col-md-2 ">

                    </div>

                    <!--                    <div class="col-md-2 text-right">-->
                    <!--                        <button class="btn-sm btn-warning"    @click="clearfilters" >Clear Filters</button>-->
                    <!--                    </div>-->

                </div>
                <div class="row mt-1">
                    <div v-if="showloader" class="col-md-10 offset-1 text-center">
                        <loader/>
                    </div>
                </div>
                <div class="row mt-2">
                    <table class="table table-bordered  table-striped text-light">
                        <thead class="thead-dark">
                        <tr>
                           <th>Id</th>
                            <th>User</th>
                            <th>Time</th>

                            <th>Affecting Action</th>
                            <th>Button Pressed</th>
                            <th>Delivery Date</th>
                            <th>Order Status</th>

                            <th>Order Items</th>
                            <th>Order Dispatches</th>

                        </tr>
                        </thead>
                        <tbody id="customerTableBody">
                        <tr v-for="inv_h in invoice_history.data">
                            <td>{{inv_h.id}}</td>

                            <td>{{inv_h.creator_user?.first_name}} {{inv_h?.creator_user.last_name}}</td>
                            <td>{{formatDatetime(inv_h.date)}}</td>
                            <td>{{inv_h.affecting_action}}</td>
                            <td>{{inv_h.affecting_button_pressed}}</td>
                            <td><span v-if="inv_h.delivery_date">{{formatDate(inv_h.delivery_date)}}</span></td>
                            <td>{{inv_h.invoice_status}}</td>
                            <td>
                                <table  >
                                    <thead>
                                    <tr>

                                        <th class=" col-md-1" >Item Code</th>
                                        <th class=" col-md-1" >Description</th>
                                        <th class=" col-md-1" >Qty</th>
                                        <th class="col-md-1" >Price</th>
                                        <th class="col-md-1" >Total</th>
                                        <th class="col-md-1" >Picked</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="item in JSON.parse(inv_h.invoice_items)">
                                     <td>{{item.pivot.itemCode}}</td>
                                     <td style="overflow: auto">{{item.pivot.itemDescription}}</td>
                                     <td>{{Number(item.pivot.quantity).toFixed(2)}}</td>
                                     <td>{{Number(item.pivot.unitPrice).toFixed(2)}}</td>
                                     <td>{{Number(item.pivot.subtotal).toFixed(2)}}</td>
                                     <td>{{Number(item.pivot.picked).toFixed(2)}}</td>

                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                            <td>
                                <table  >
                                    <thead>
                                    <tr>

                                        <th class=" col-md-1" >ID</th>
                                        <th class=" col-md-1" >Mode</th>
                                        <th class=" col-md-1" >Status</th>
                                        <th class="col-md-1" >Location</th>
                                        <th class="col-md-1" >Date</th>

                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="dis in JSON.parse(inv_h.invoice_dispatches)">
                                        <td>{{dis.id}}</td>
                                        <td>{{dis.mode}}</td>
                                        <td>{{dis.status}}</td>
                                        <td>{{locations?.find((l)=>l.id==dis.location_id).location_name}}</td>
                                        <td>{{formatDate(dis.date)}}</td>



                                    </tr>
                                    </tbody>
                                </table>
                            </td>


                        </tr>
                        </tbody>
                    </table>

                    <b-modal  v-model="claim_modal" hide-footer  centered  v-if="selected_claim"   >
                        <div class="row">
                            <div class="col-md-12">
                                <h1 class="text-center" >Claim Details</h1>
                                <table class="table table-bordered text-dark" >
                                    <thead>
                                    <tr>
                                        <!--                           <th>ID</th>-->

                                        <th>ItemCode</th>

                                        <th>Description </th>
                                        <th>  Qty  </th>
                                        <th> UnitPrice </th>
                                        <th> SubTotal </th>


                                    </tr>
                                    </thead>
                                    <tbody >

                                    <tr  v-for="item in selected_claim.invoice.items">


                                        <td >{{item.pivot.itemCode}} </td>

                                        <td>{{item.pivot.itemDescription}} </td>
                                        <td>{{item.pivot.quantity}} </td>
                                        <td>{{Number(item.pivot.unitPrice).toFixed(2)}} </td>
                                        <td>{{Number(item.pivot.subtotal).toFixed(2)}} </td>





                                    </tr>

                                    </tbody>
                                </table>
                                <table class="table table-bordered text-dark" >
                                    <thead>
                                    <tr>


                                        <th>Order Sub Total</th>

                                        <th>Vat</th>
                                        <th>  Total Paid </th>



                                    </tr>
                                    </thead>
                                    <tbody >
                                    <tr>
                                        <td>{{selected_claim.invoice.subTotal}}</td>
                                        <td>{{selected_claim.invoice.vat}}</td>
                                        <td>{{selected_claim.invoice.totalPaid}}</td>
                                    </tr>

                                    </tbody>
                                </table>

                                <div class="row">
                                    <div class="col-md-12">
                                        <label for="manager-notes" class="font-weight-bold">Manager Notes</label>
                                        <b-form-textarea
                                            v-model="selected_claim.manager_notes"
                                            id="manager-notes"
                                            placeholder="Enter notes"
                                            rows="3"
                                        ></b-form-textarea>
                                    </div>

                                    <div class="col-md-4 mt-2">
                                        <label for="credit-amount" class="font-weight-bold">Credit Amount</label>
                                        <b-input
                                            v-model="selected_claim.claim_amount"
                                            id="credit-amount"
                                            placeholder="credit amount"
                                            type="number"
                                        ></b-input>
                                    </div>
                                </div>



                                <div class="d-flex justify-content-center mt-3">
                                    <button
                                        v-if="!authenticatedUser.permissions.includes('super')"
                                        class="btn btn-success d-flex align-items-center"
                                        @click="approveclaim(selected_claim.id)"
                                        :disabled="saving ||!selected_claim.manager_notes || !selected_claim.claim_amount"
                                    >
                                        <span>Approve</span>
                                        <span v-if="saving" class="saving-dots ml-1">
                                      <span></span><span></span><span></span>
                                   </span>

                                    </button>

                                    <button
                                        v-if="authenticatedUser.permissions.includes('super')"
                                        class="btn btn-success d-flex align-items-center"
                                        @click="completeclaim(selected_claim.id)"
                                        :disabled="saving ||!selected_claim.manager_notes || !selected_claim.claim_amount"
                                    >
                                        <span>Complete</span>
                                        <span v-if="saving" class="saving-dots ml-1">
                                      <span></span><span></span><span></span>
                                   </span>

                                    </button>

                                    <button class="btn btn-primary hide" ></button>
                                    <button class="btn btn-secondary me-5" @click="claim_modal = false">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </b-modal>
                </div>



            </div>

        </div>

    </div>

</template>

<script>
//import apiService from "@/service/apiService";
import { mapActions } from "vuex";
import { mapGetters } from 'vuex';
import { mapState } from 'vuex';
import sidebar from "@/components/layout/sidebar";
import showrealtime from "@/components/showrealtime";
import vSelect from "vue-select";
import Welcomenote from "@/pages/admin/mypos/welcomenote.vue";
import URL from "@/constants/baseurl";
import Loader from "@/components/loader.vue";
import moment from "moment/moment";
//import vSelect from "vue-select";

import apiService from "@/service/apiService";
import Swal from "sweetalert2";
import axios from "axios";


export default {
    name: "invoice_history",

    components:{Loader, Welcomenote, 'v-select': vSelect,'sidebar': sidebar,'ShowRealTime':showrealtime},
    computed: {
        ...mapGetters(['AuthenticatedUser']),
        ...mapState('claims',['claimfilters']),
        //  ...mapState('customers', ['customers']), not using this state
        ...mapState('invoice', ['branches']),
        totalPages() {
            const perpage = this.invoice_history.per_page;
            const total=this.invoice_history.total;

            return Math.ceil(total / perpage);
        },
        authenticatedUser() {
            let user = localStorage.getItem('user');
            user = JSON.parse(user)
            return user
        },


    },
    data() {
        return {
            saving:false,

            roles: [],
            user: {},
            // perPage:100,
            // currentPage: 1,
            invoice_history:[],
            showloader:false,

            claim_modal:false,
            selected_claim:null,
            locations:[]



        };
    },
    async created() {
        //  await this.getUsers();
        //   await this.getRoles();
        // await this.getbranches()
        // await this.getcashiers()
        this.viewType = this.$route.query.type;
        this.invoice_id = this.$route.query.id;

        const promises = [

            this.reloadcb(),
            this.get_invoice_history(),
            this.getlocations()

        ];
        await Promise.all(promises);

    },
    async mounted() {


    },
    updated() {


    },
    methods: {
        ...mapActions(['login', 'processLogoutManual']),
        ...mapActions('invoice', ['getbranches']),

        async getlocations(){
            const {data} = await apiService.get(`/locations`);
            //  console.log('branches', data)
            this.locations= data.sort((a, b) => {
                if (a.id === 14) return -1;
                if (b.id === 14) return 1;
                return 0;
            });

            // if(!this.authenticatedUser.permissions.includes('super')){
            //
            //     this.location_id_to= this.locations.find((lc)=>lc.branch_id==this.authenticatedUser.branch_id).id
            // }


        },







        formatDate(date){
            let date1 = new Date(date);
            let date2 =  moment(date1).format('D MMMM, YYYY');

            return date2;
        },

        formatDatetime(date){
            let date1 = new Date(date);
            return moment(date1).format('D MMMM, YYYY, h:mm A');
        },
        async signOut() {
            await this.processLogoutManual();
            // await this.$router.push({ name: "Login" });
            window.location.href = this.$router.resolve({ name: "Login" }).href;
        },
        async getUsers(role = '') {
            const { data } = await this.$axios.get(`user?role=${role}`);
            this.items = data;
        },
        async getRoles() {
            const { data } = await this.$axios.get('role');
            this.roles = data.roles;
        },
        filterUsers(value) {
            this.getUsers(value)
        },


        async reloadcb(){
            if(this.branches.length==0){

                //   alert(this.branches.length)
             //   await this.getbranches()
                // console.log(this.latestinvoices.data.length,'here')

            }

        },

        async get_paged_data(button){
            let current_page= this.claims.current_page
            this.claimfilters.page=current_page



            if(button=='next'){

                this.claimfilters.page=current_page+1

                await   this.get_invoice_history()

            }
            if(button=='prev'){
                this.claimfilters.page=current_page-1

                await  this.get_invoice_history()


            }

        },
        async  get_invoice_history() {
            let user = localStorage.getItem('user');
            user=  JSON.parse(user)
            const apiToken = localStorage.getItem('token');
            let url=`${URL.BASEURL}/api/get-invoice-history`
            let filters ={
                invoice_id:this.invoice_id,
                name:this.claimfilters.customer_name,
                telephone:this.claimfilters.phone_number,
                status:this.claimfilters.status,
                order_id:this.claimfilters.order_id,

                page:this.claimfilters.page,


            };
            if(user.permissions.includes('super')){

                filters.branch_id=this.claimfilters.branch_id;

            } else {
                filters.branch_id=user.branch.id;
            }
            this.showloader=true
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiToken}`
                    },
                    body: JSON.stringify(filters)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const res = await response.json();
                this.invoice_history=res
                // console.log('customers:', res);
            } catch (error) {
                console.error('Error:', error);
            }
            this.showloader=false
        }

    },
}
</script>

<style scoped>
@import '../../../assets/styles/pos.css';
.hide {
    visibility: hidden !important;
}


.saving-dots {

    align-items: center;
}

.saving-dots span {
    width: 6px;   /* dot size */
    height: 6px;
    margin: 0 3px;
    background: white;   /* adjust to match button text color */
    border-radius: 50%;
    display: inline-block;
    animation: bounce 1.2s infinite;
}

.saving-dots span:nth-child(1) { animation-delay: 0s; }
.saving-dots span:nth-child(2) { animation-delay: 0.2s; }
.saving-dots span:nth-child(3) { animation-delay: 0.4s; }



</style>
